import axios from 'axios';

export default {
    getDiscipleTree({ rootGetters, commit, state }) {
        return new Promise((resolve, reject) => {
            axios.get(
                '/disciples/myDiscipleTree',
                {
                    headers: {
                        Authorization: rootGetters.token,
                    },
                },
            )
                .then((response) => {
                    // eslint-disable-next-line no-console
                    // console.log(response.data);
                    commit('setDiscipleTree', response.data);
                })
                .catch((error) => {
                    commit('setError', error);
                });
        });
    }
};
